import { NavegacionProductos } from '../../components';

const FrijolesRefritosConChicharron = () => {
    return <NavegacionProductos />;
};

export default FrijolesRefritosConChicharron;
